import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-movie-2-line text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-bold text-background-50" style={{ fontFamily: 'var(--font-heading)' }}>
                极速影视
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              极速影视高清电影大全，每日更新最新院线大片和热门推荐。全部免费在线观看不缓冲，极速影视为您提供极致的观影体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">电影分类</h4>
            <div className="flex flex-wrap gap-2">
              <Link to="/category/dongzuo" className="text-xs text-background-400 hover:text-primary-400 transition-colors bg-background-900 px-3 py-1.5 rounded-md whitespace-nowrap">动作</Link>
              <Link to="/category/xiju" className="text-xs text-background-400 hover:text-primary-400 transition-colors bg-background-900 px-3 py-1.5 rounded-md whitespace-nowrap">喜剧</Link>
              <Link to="/category/kehuan" className="text-xs text-background-400 hover:text-primary-400 transition-colors bg-background-900 px-3 py-1.5 rounded-md whitespace-nowrap">科幻</Link>
              <Link to="/category/aiqing" className="text-xs text-background-400 hover:text-primary-400 transition-colors bg-background-900 px-3 py-1.5 rounded-md whitespace-nowrap">爱情</Link>
              <Link to="/category/kongbu" className="text-xs text-background-400 hover:text-primary-400 transition-colors bg-background-900 px-3 py-1.5 rounded-md whitespace-nowrap">恐怖</Link>
              <Link to="/category/donghua" className="text-xs text-background-400 hover:text-primary-400 transition-colors bg-background-900 px-3 py-1.5 rounded-md whitespace-nowrap">动画</Link>
              <Link to="/category/xuanyi" className="text-xs text-background-400 hover:text-primary-400 transition-colors bg-background-900 px-3 py-1.5 rounded-md whitespace-nowrap">悬疑</Link>
              <Link to="/category/juqing" className="text-xs text-background-400 hover:text-primary-400 transition-colors bg-background-900 px-3 py-1.5 rounded-md whitespace-nowrap">剧情</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">首页</Link></li>
              <li><Link to="/category/all" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">全部电影</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
            <div className="space-y-2 text-sm text-background-400">
              <p className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400"></i>
                <span>contact@jisumovies.com</span>
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-phone-line text-primary-400"></i>
                <span>400-888-6688</span>
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-map-pin-line text-primary-400"></i>
                <span>北京市朝阳区光华路88号</span>
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 极速影视 版权所有 | 京ICP备2024XXXXXXXX号
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">服务条款</a>
            <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}